import { render, staticRenderFns } from "./BrightcoveVideo.vue?vue&type=template&id=84fb7b2e&"
import script from "./BrightcoveVideo.vue?vue&type=script&lang=js&"
export * from "./BrightcoveVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports